import { render } from "./HeaderVideo.vue?vue&type=template&id=7b639474&scoped=true"
import script from "./HeaderVideo.vue?vue&type=script&lang=js"
export * from "./HeaderVideo.vue?vue&type=script&lang=js"

import "./HeaderVideo.vue?vue&type=style&index=0&id=7b639474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b639474"]])

export default __exports__